module.exports = __webpack_public_path__ + "img/GR126.0b538e24.svg";